"use client";

import { Icon } from "@pamperedchef/design-system";
import * as styles from "./CheckList.module.scss";

export interface CheckListProps {
	items: string[];
	/** Optional list heading rendered above the items. */
	heading?: string;
}

/**
 * Shared check-marked list. Reused for offer features, products-in-kit, and
 * also-includes. Each row pairs a teal `check` icon with Lexend body
 * text. Presentational, props-in.
 */
export function CheckList({ items, heading }: CheckListProps) {
	if (!items.length) return null;

	return (
		<div className={styles["check-list"]} data-component="CheckList">
			{heading ? (
				<p className={styles["check-list__heading"]}>{heading}</p>
			) : null}
			<ul className={styles["check-list__items"]}>
				{items.map((item, i) => (
					<li
						key={`${item}-${i}`}
						className={styles["check-list__item"]}
					>
						<span
							className={styles["check-list__icon"]}
							aria-hidden="true"
						>
							<Icon name="check" size={16} />
						</span>
						<span className={styles["check-list__label"]}>
							{item}
						</span>
					</li>
				))}
			</ul>
		</div>
	);
}
